export interface CreateRoleDto {
  binusianId: string;
  name: string;
  access: string[];
}

export namespace CreateRoleDto {
  export function toJSON(data: CreateRoleDto) {
    return {
      binusianId: data.binusianId,
      roleName: data.name,
      access: data.access.filter((e) => e !== ""),
    };
  }
}
